import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class PageTitle extends PureComponent {

  static propTypes = {
    title: PropTypes.object.isRequired,
  };

  render() {
    return <h1>{this.props.title}</h1>;
  }

}
